export const IS_ACCOUNT_TFSA = 'TFSA';
